function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ref;
function cov_1q9eio50nx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx";
  var hash = "3e5a1606c108693d27487ca27c0c2fd240920902";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 164,
          column: 70
        },
        end: {
          line: 311,
          column: 1
        }
      },
      "1": {
        start: {
          line: 315,
          column: 86
        },
        end: {
          line: 325,
          column: 1
        }
      },
      "2": {
        start: {
          line: 349,
          column: 2
        },
        end: {
          line: 364,
          column: 4
        }
      },
      "3": {
        start: {
          line: 353,
          column: 10
        },
        end: {
          line: 353,
          column: 92
        }
      },
      "4": {
        start: {
          line: 356,
          column: 10
        },
        end: {
          line: 360,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "Spritesheet",
        decl: {
          start: {
            line: 348,
            column: 24
          },
          end: {
            line: 348,
            column: 35
          }
        },
        loc: {
          start: {
            line: 348,
            column: 38
          },
          end: {
            line: 365,
            column: 1
          }
        },
        line: 348
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 352,
            column: 44
          },
          end: {
            line: 352,
            column: 45
          }
        },
        loc: {
          start: {
            line: 353,
            column: 10
          },
          end: {
            line: 353,
            column: 92
          }
        },
        line: 353
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 355,
            column: 58
          },
          end: {
            line: 355,
            column: 59
          }
        },
        loc: {
          start: {
            line: 356,
            column: 10
          },
          end: {
            line: 360,
            column: 12
          }
        },
        line: 356
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3e5a1606c108693d27487ca27c0c2fd240920902"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1q9eio50nx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1q9eio50nx();
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { bricks } from "../../system/bricks.types.mjs";
import ArrowDown from "./SpritesheetIcons/ArrowDown.mjs";
import ArrowLeft from "./SpritesheetIcons/ArrowLeft.mjs";
import ArrowRight from "./SpritesheetIcons/ArrowRight.mjs";
import ArrowUp from "./SpritesheetIcons/ArrowUp.mjs";
import Avatar from "./SpritesheetIcons/Avatar.mjs";
import AvatarFilled from "./SpritesheetIcons/AvatarFilled.mjs";
import Bathroom from "./SpritesheetIcons/Bathroom.mjs";
import BathroomFilled from "./SpritesheetIcons/BathroomFilled.mjs";
import BathroomVersionTwo from "./SpritesheetIcons/BathroomVersionTwo.mjs";
import BathroomVersionTwoFilled from "./SpritesheetIcons/BathroomVersionTwoFilled.mjs";
import Bedroom from "./SpritesheetIcons/Bedroom.mjs";
import BedroomFilled from "./SpritesheetIcons/BedroomFilled.mjs";
import CenterFocusStrong from "./SpritesheetIcons/CenterFocusStrong.mjs";
import Chat from "./SpritesheetIcons/Chat.mjs";
import ChatInactive from "./SpritesheetIcons/ChatInactive.mjs";
import ChatVersionTwo from "./SpritesheetIcons/ChatVersionTwo.mjs";
import ChatVersionTwoFilled from "./SpritesheetIcons/ChatVersionTwoFilled.mjs";
import Checkmark from "./SpritesheetIcons/Checkmark.mjs";
import ChevronDown from "./SpritesheetIcons/ChevronDown.mjs";
// size-specific icons
import ChevronDown12 from "./SpritesheetIcons/ChevronDown12.mjs";
import ChevronDown16 from "./SpritesheetIcons/ChevronDown16.mjs";
import ChevronLeft from "./SpritesheetIcons/ChevronLeft.mjs";
import ChevronLeft12 from "./SpritesheetIcons/ChevronLeft12.mjs";
import ChevronLeft16 from "./SpritesheetIcons/ChevronLeft16.mjs";
import ChevronRight from "./SpritesheetIcons/ChevronRight.mjs";
import ChevronRight12 from "./SpritesheetIcons/ChevronRight12.mjs";
import ChevronRight16 from "./SpritesheetIcons/ChevronRight16.mjs";
import ChevronUp from "./SpritesheetIcons/ChevronUp.mjs";
import ChevronUp12 from "./SpritesheetIcons/ChevronUp12.mjs";
import ChevronUp16 from "./SpritesheetIcons/ChevronUp16.mjs";
import Close from "./SpritesheetIcons/Close.mjs";
import Close16 from "./SpritesheetIcons/Close16.mjs";
import ContactPhone from "./SpritesheetIcons/ContactPhone.mjs";
import Date from "./SpritesheetIcons/Date.mjs";
import DateAdd from "./SpritesheetIcons/DateAdd.mjs";
import DateAddFilled from "./SpritesheetIcons/DateAddFilled.mjs";
import DateChecked from "./SpritesheetIcons/DateChecked.mjs";
import DateCheckedFilled from "./SpritesheetIcons/DateCheckedFilled.mjs";
import DateFilled from "./SpritesheetIcons/DateFilled.mjs";
import DateSubtract from "./SpritesheetIcons/DateSubtract.mjs";
import DateSubtractFilled from "./SpritesheetIcons/DateSubtractFilled.mjs";
import DocumentCheck from "./SpritesheetIcons/DocumentCheck.mjs";
import DocumentCheckFilled from "./SpritesheetIcons/DocumentCheckFilled.mjs";
import Door from "./SpritesheetIcons/Door.mjs";
import DoorFilled from "./SpritesheetIcons/DoorFilled.mjs";
import DoubleChevron from "./SpritesheetIcons/DoubleChevron.mjs";
import DoubleMove from "./SpritesheetIcons/DoubleMove.mjs";
import EarlyAccess from "./SpritesheetIcons/EarlyAccess.mjs";
import Edit from "./SpritesheetIcons/Edit.mjs";
import EditFilled from "./SpritesheetIcons/EditFilled.mjs";
import Email from "./SpritesheetIcons/Email.mjs";
import EmailFilled from "./SpritesheetIcons/EmailFilled.mjs";
import Equal from "./SpritesheetIcons/Equal.mjs";
import Expertise from "./SpritesheetIcons/Expertise.mjs";
import Favorite from "./SpritesheetIcons/Favorite.mjs";
import FavoriteFilled from "./SpritesheetIcons/FavoriteFilled.mjs";
import Filter from "./SpritesheetIcons/Filter.mjs";
import Garage from "./SpritesheetIcons/Garage.mjs";
import GarageFilled from "./SpritesheetIcons/GarageFilled.mjs";
import Geo from "./SpritesheetIcons/Geo.mjs";
import GeoFilled from "./SpritesheetIcons/GeoFilled.mjs";
import Home from "./SpritesheetIcons/Home.mjs";
import HomeChat from "./SpritesheetIcons/HomeChat.mjs";
import HomeChatFilled from "./SpritesheetIcons/HomeChatFilled.mjs";
import HomeCost from "./SpritesheetIcons/HomeCost.mjs";
import HomeCostFilled from "./SpritesheetIcons/HomeCostFilled.mjs";
import HomeFilled from "./SpritesheetIcons/HomeFilled.mjs";
import HomeLocation from "./SpritesheetIcons/HomeLocation.mjs";
import HomeLocationFilled from "./SpritesheetIcons/HomeLocationFilled.mjs";
import Info from "./SpritesheetIcons/Info.mjs";
import InfoFilled from "./SpritesheetIcons/InfoFilled.mjs";
import Invite from "./SpritesheetIcons/Invite.mjs";
import InviteFilled from "./SpritesheetIcons/InviteFilled.mjs";
import InvitePlus from "./SpritesheetIcons/InvitePlus.mjs";
import Jewel from "./SpritesheetIcons/Jewel.mjs";
import Levels from "./SpritesheetIcons/Levels.mjs";
import LevelsFilled from "./SpritesheetIcons/LevelsFilled.mjs";
import List from "./SpritesheetIcons/List.mjs";
import LiveHelp from "./SpritesheetIcons/LiveHelp.mjs";
import Location from "./SpritesheetIcons/Location.mjs";
import LocationPin from "./SpritesheetIcons/LocationPin.mjs";
import LocationPinFilled from "./SpritesheetIcons/LocationPinFilled.mjs";
import LocationPinHome from "./SpritesheetIcons/LocationPinHome.mjs";
import LocationPinHomeFilled from "./SpritesheetIcons/LocationPinHomeFilled.mjs";
import Lock from "./SpritesheetIcons/Lock.mjs";
import LockFilled from "./SpritesheetIcons/LockFilled.mjs";
import Logo from "./SpritesheetIcons/Logo.mjs";
import Map from "./SpritesheetIcons/Map.mjs";
import Menu from "./SpritesheetIcons/Menu.mjs";
import Minus from "./SpritesheetIcons/Minus.mjs";
import Money from "./SpritesheetIcons/Money.mjs";
import Move from "./SpritesheetIcons/Move.mjs";
import MoveFilled from "./SpritesheetIcons/MoveFilled.mjs";
import MultipleOffers from "./SpritesheetIcons/MultipleOffers.mjs";
import MultipleOffersFilled from "./SpritesheetIcons/MultipleOffersFilled.mjs";
import Neighborhood from "./SpritesheetIcons/Neighborhood.mjs";
import NeighborhoodFilled from "./SpritesheetIcons/NeighborhoodFilled.mjs";
import New from "./SpritesheetIcons/New.mjs";
import NewConstruction from "./SpritesheetIcons/NewConstruction.mjs";
import NewTab from "./SpritesheetIcons/NewTab.mjs";
import NewTabFilled from "./SpritesheetIcons/NewTabFilled.mjs";
import Notification from "./SpritesheetIcons/Notification.mjs";
import Obo from "./SpritesheetIcons/Obo.mjs";
import Offer from "./SpritesheetIcons/Offer.mjs";
import OfferInactive from "./SpritesheetIcons/OfferInactive.mjs";
import Open from "./SpritesheetIcons/Open.mjs";
// Old Sprite Sheets below: please update to new designs and naming
import Opendoor from "./SpritesheetIcons/Opendoor.mjs";
import Pdf from "./SpritesheetIcons/Pdf.mjs";
import Phone from "./SpritesheetIcons/Phone.mjs";
import PhoneFilled from "./SpritesheetIcons/PhoneFilled.mjs";
import PhotoLibrary from "./SpritesheetIcons/PhotoLibrary.mjs";
import Placeholder from "./SpritesheetIcons/Placeholder.mjs";
import Plus from "./SpritesheetIcons/Plus.mjs";
import Popular from "./SpritesheetIcons/Popular.mjs";
import ProgressBar from "./SpritesheetIcons/ProgressBar.mjs";
import Question from "./SpritesheetIcons/Question.mjs";
import QuestionMark from "./SpritesheetIcons/QuestionMark.mjs";
import Rate from "./SpritesheetIcons/Rate.mjs";
import Refresh from "./SpritesheetIcons/Refresh.mjs";
import RefreshFilled from "./SpritesheetIcons/RefreshFilled.mjs";
import Reset from "./SpritesheetIcons/Reset.mjs";
import Search from "./SpritesheetIcons/Search.mjs";
import SearchFilled from "./SpritesheetIcons/SearchFilled.mjs";
import See from "./SpritesheetIcons/See.mjs";
import SeeFilled from "./SpritesheetIcons/SeeFilled.mjs";
import SeeHidden from "./SpritesheetIcons/SeeHidden.mjs";
import Share from "./SpritesheetIcons/Share.mjs";
import ShareFilled from "./SpritesheetIcons/ShareFilled.mjs";
import Shower from "./SpritesheetIcons/Shower.mjs";
import ShowerFilled from "./SpritesheetIcons/ShowerFilled.mjs";
import Sign from "./SpritesheetIcons/Sign.mjs";
import SignFilled from "./SpritesheetIcons/SignFilled.mjs";
import Sink from "./SpritesheetIcons/Sink.mjs";
import SinkFilled from "./SpritesheetIcons/SinkFilled.mjs";
import SinkVersionTwo from "./SpritesheetIcons/SinkVersionTwo.mjs";
import SinkVersionTwoFilled from "./SpritesheetIcons/SinkVersionTwoFilled.mjs";
import Sliders from "./SpritesheetIcons/Sliders.mjs";
import SlidersFilled from "./SpritesheetIcons/SlidersFilled.mjs";
import SquareFeet from "./SpritesheetIcons/SquareFeet.mjs";
import SquareFeetFilled from "./SpritesheetIcons/SquareFeetFilled.mjs";
import Star from "./SpritesheetIcons/Star.mjs";
import StarFilled from "./SpritesheetIcons/StarFilled.mjs";
import Telephone from "./SpritesheetIcons/Telephone.mjs";
import ThreeSixty from "./SpritesheetIcons/ThreeSixty.mjs";
import ThreeSixtyVersionTwo from "./SpritesheetIcons/ThreeSixtyVerisonTwo.mjs";
import Trash from "./SpritesheetIcons/Trash.mjs";
import TrashFilled from "./SpritesheetIcons/TrashFilled.mjs";
import UnlockLeft from "./SpritesheetIcons/UnlockLeft.mjs";
import UnlockLeftFilled from "./SpritesheetIcons/UnlockLeftFilled.mjs";
import UnlockRight from "./SpritesheetIcons/UnlockRight.mjs";
import UnlockRightFilled from "./SpritesheetIcons/UnlockRightFilled.mjs";
import Video from "./SpritesheetIcons/Video.mjs";
import VideoFilled from "./SpritesheetIcons/VideoFilled.mjs";
import Warning from "./SpritesheetIcons/Warning.mjs";
// DO NOT EXPORT: If you need all the names of the icons, use the
// SPRITESHEET_ICONS_MANIFEST
var SPRITESHEET_ICONS = (cov_1q9eio50nx().s[0]++, (_ref = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, ArrowDown.name, ArrowDown.svg), ArrowLeft.name, ArrowLeft.svg), ArrowRight.name, ArrowRight.svg), ArrowUp.name, ArrowUp.svg), Avatar.name, Avatar.svg), AvatarFilled.name, AvatarFilled.svg), Bathroom.name, Bathroom.svg), BathroomFilled.name, BathroomFilled.svg), BathroomVersionTwo.name, BathroomVersionTwo.svg), BathroomVersionTwoFilled.name, BathroomVersionTwoFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Bedroom.name, Bedroom.svg), BedroomFilled.name, BedroomFilled.svg), CenterFocusStrong.name, CenterFocusStrong.svg), Chat.name, Chat.svg), ChatInactive.name, ChatInactive.svg), ChatVersionTwo.name, ChatVersionTwo.svg), ChatVersionTwoFilled.name, ChatVersionTwoFilled.svg), Checkmark.name, Checkmark.svg), ChevronDown.name, ChevronDown.svg), ChevronLeft.name, ChevronLeft.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, ChevronRight.name, ChevronRight.svg), ChevronUp.name, ChevronUp.svg), Close.name, Close.svg), ContactPhone.name, ContactPhone.svg), Date.name, Date.svg), DateFilled.name, DateFilled.svg), DateAdd.name, DateAdd.svg), DateAddFilled.name, DateAddFilled.svg), DateChecked.name, DateChecked.svg), DateCheckedFilled.name, DateCheckedFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, DateSubtract.name, DateSubtract.svg), DateSubtractFilled.name, DateSubtractFilled.svg), DocumentCheck.name, DocumentCheck.svg), DocumentCheckFilled.name, DocumentCheckFilled.svg), Door.name, Door.svg), DoorFilled.name, DoorFilled.svg), DoubleChevron.name, DoubleChevron.svg), DoubleMove.name, DoubleMove.svg), EarlyAccess.name, EarlyAccess.svg), Edit.name, Edit.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, EditFilled.name, EditFilled.svg), Email.name, Email.svg), EmailFilled.name, EmailFilled.svg), Equal.name, Equal.svg), Expertise.name, Expertise.svg), Favorite.name, Favorite.svg), FavoriteFilled.name, FavoriteFilled.svg), Filter.name, Filter.svg), Garage.name, Garage.svg), GarageFilled.name, GarageFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Geo.name, Geo.svg), GeoFilled.name, GeoFilled.svg), Home.name, Home.svg), HomeFilled.name, HomeFilled.svg), HomeChat.name, HomeChat.svg), HomeChatFilled.name, HomeChatFilled.svg), HomeCost.name, HomeCost.svg), HomeCostFilled.name, HomeCostFilled.svg), HomeLocation.name, HomeLocation.svg), HomeLocationFilled.name, HomeLocationFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Info.name, Info.svg), InfoFilled.name, InfoFilled.svg), Invite.name, Invite.svg), InviteFilled.name, InviteFilled.svg), InvitePlus.name, InvitePlus.svg), Jewel.name, Jewel.svg), Levels.name, Levels.svg), LevelsFilled.name, LevelsFilled.svg), List.name, List.svg), LiveHelp.name, LiveHelp.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Location.name, Location.svg), LocationPin.name, LocationPin.svg), LocationPinFilled.name, LocationPinFilled.svg), LocationPinHome.name, LocationPinHome.svg), LocationPinHomeFilled.name, LocationPinHomeFilled.svg), Lock.name, Lock.svg), LockFilled.name, LockFilled.svg), Logo.name, Logo.svg), Map.name, Map.svg), Menu.name, Menu.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Minus.name, Minus.svg), Money.name, Money.svg), Move.name, Move.svg), MoveFilled.name, MoveFilled.svg), MultipleOffers.name, MultipleOffers.svg), MultipleOffersFilled.name, MultipleOffersFilled.svg), Neighborhood.name, Neighborhood.svg), NeighborhoodFilled.name, NeighborhoodFilled.svg), New.name, New.svg), NewConstruction.name, NewConstruction.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, NewTab.name, NewTab.svg), NewTabFilled.name, NewTabFilled.svg), Notification.name, Notification.svg), Obo.name, Obo.svg), Offer.name, Offer.svg), OfferInactive.name, OfferInactive.svg), Open.name, Open.svg), Pdf.name, Pdf.svg), Phone.name, Phone.svg), PhoneFilled.name, PhoneFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, PhotoLibrary.name, PhotoLibrary.svg), Placeholder.name, Placeholder.svg), Plus.name, Plus.svg), Popular.name, Popular.svg), Question.name, Question.svg), QuestionMark.name, QuestionMark.svg), Rate.name, Rate.svg), Refresh.name, Refresh.svg), RefreshFilled.name, RefreshFilled.svg), Reset.name, Reset.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Search.name, Search.svg), SearchFilled.name, SearchFilled.svg), See.name, See.svg), SeeFilled.name, SeeFilled.svg), SeeHidden.name, SeeHidden.svg), Share.name, Share.svg), ShareFilled.name, ShareFilled.svg), Shower.name, Shower.svg), ShowerFilled.name, ShowerFilled.svg), Sign.name, Sign.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, SignFilled.name, SignFilled.svg), Sink.name, Sink.svg), SinkFilled.name, SinkFilled.svg), SinkVersionTwo.name, SinkVersionTwo.svg), SinkVersionTwoFilled.name, SinkVersionTwoFilled.svg), Sliders.name, Sliders.svg), SlidersFilled.name, SlidersFilled.svg), SquareFeet.name, SquareFeet.svg), SquareFeetFilled.name, SquareFeetFilled.svg), Star.name, Star.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, StarFilled.name, StarFilled.svg), Telephone.name, Telephone.svg), ThreeSixty.name, ThreeSixty.svg), ThreeSixtyVersionTwo.name, ThreeSixtyVersionTwo.svg), Trash.name, Trash.svg), TrashFilled.name, TrashFilled.svg), UnlockLeft.name, UnlockLeft.svg), UnlockLeftFilled.name, UnlockLeftFilled.svg), UnlockRight.name, UnlockRight.svg), UnlockRightFilled.name, UnlockRightFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Video.name, Video.svg), VideoFilled.name, VideoFilled.svg), Warning.name, Warning.svg), Opendoor.name, Opendoor.svg), ProgressBar.name, ProgressBar.svg)));

// DO NOT EXPORT: If you need all the names of the icons, use the
// SIZE_SPECIFIC__ICONS_MANIFEST
var SIZE_SPECIFIC_SPRITESHEET_ICONS = (cov_1q9eio50nx().s[1]++, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ChevronDown12.name, ChevronDown12.svg), ChevronDown16.name, ChevronDown16.svg), ChevronLeft12.name, ChevronLeft12.svg), ChevronLeft16.name, ChevronLeft16.svg), ChevronRight12.name, ChevronRight12.svg), ChevronRight16.name, ChevronRight16.svg), ChevronUp12.name, ChevronUp12.svg), ChevronUp16.name, ChevronUp16.svg), Close16.name, Close16.svg));

/**
 * The spritesheet component contains all of the EERO icons. It is injected once
 * per page. Individual icons are then made using the Icon component.
 * Icon takes `name` as a prop which refers to the keys in the
 * `SPRITESHEET_ICONS` object. To add an icon to the spritesheet:
 * 1. Add a new "name" to the SPRITESHEET_ICONS_MANIFEST object in ./SpritesheetManifest.tsx
 * 2. Add a new file to './SpritesheetIcons/YourNewIcon.tsx' and export
 *    the `name` and `svg` object.
 * 3. Add to the SPRITESHEET_ICONS object, by importing and adding
 *    import YourNewIcon from './SpritesheetIcons/YourNewIcon'
 *    ...
 *    [YourNewIcon.name]: YourNewIcon.svg
 * a key and the raw SVG code as value to the `SPRITESHEET_ICONS` object.
 *
 * When adding an icon to the spritesheet for which the color is meant to be
 * dynamic set each fill and stroke that is meant to be a dynamic color to
 * `currentColor`. For icons with static colors leave the strokes and fills as
 * is.
 *
 * [One-pager](https://docs.google.com/document/d/16wEXOzW3fPz3WafU6wJ8gtYAJl70_CE8TJUP8_-rgYs/edit?usp=sharing)
 */
export default function Spritesheet() {
  cov_1q9eio50nx().f[0]++;
  cov_1q9eio50nx().s[2]++;
  return /*#__PURE__*/React.createElement(bricks.svg, {
    opacity: 0,
    width: 0,
    height: 0,
    display: "block",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, Object.keys(SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[1]++;
    cov_1q9eio50nx().s[3]++;
    return /*#__PURE__*/React.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SPRITESHEET_ICONS[id]
      }
    });
  }), Object.keys(SIZE_SPECIFIC_SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[2]++;
    cov_1q9eio50nx().s[4]++;
    return /*#__PURE__*/React.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SIZE_SPECIFIC_SPRITESHEET_ICONS[id]
      }
    });
  })));
}